import { render, staticRenderFns } from "./buddingEditor.vue?vue&type=template&id=b5f605b8&scoped=true"
import script from "./buddingEditor.vue?vue&type=script&lang=js"
export * from "./buddingEditor.vue?vue&type=script&lang=js"
import style0 from "./buddingEditor.vue?vue&type=style&index=0&id=b5f605b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f605b8",
  null
  
)

export default component.exports